export const SET_HEADER_EVENTS = 'FLEX_PANEL.SET_HEADER_EVENTS';
export const SET_CUSTOM_HEADER = 'FLEX_PANEL.SET_CUSTOM_HEADER';
export const SET_TITLE_VISIBILITY = 'FLEX_PANEL.SET_TITLE_VISIBILITY';
export const SET_PANEL_TITLE = 'FLEX_PANEL.SET_PANEL_TITLE';
export const DIMENSIONS_UPDATED = 'FLEX_PANEL.DIMENSIONS_UPDATED';
